/**
 * Mobile Menu functionality
 *
 * @author Matt Asmar <github.com/MattXXV>
 */

(function ($, once) {
  'use strict';

  const $menuSpeed = 300;

  // define mobile menu assets in play
  let $menuWrap;
  let $topLevelLinks;
  let $mobileSubMenus;
  let $mobileSubMenuLinks;
  let $mobileButton;

  let $dropdownLinks;
  let $dropdownMenus;

  Drupal.behaviors.initializeMainMobileMenu = {
    attach: (context) => {
      once('initializeMainMobileMenu', 'html').forEach(function (element) {
        initialize();
      });
    },
  };

  // Check and see if Tier 1 link contains sub-menu if so add class has-sub
  function setClasses() {
    $topLevelLinks.each(function () {
      if ($(this).children().length > 1) {
        $(this).addClass('has-sub');

        // Inserting Overview link on sub menus
        const $subMenu = $(this).find('.menu-level-1');
        const overviewData = $(this).find('> a').attr('href');
        const overviewLi = document.createElement('li');
        const overviewLink = document.createElement('a');
        overviewLi.classList.add('menu-item');
        overviewLi.appendChild(overviewLink);
        $subMenu.prepend(overviewLi);
        overviewLink.setAttribute('href', overviewData);
        overviewLink.textContent = 'Overview';
      }
    });
  }

  // Menu Button - toggles active class on both self and menu wrapper element
  function mobileToggleButton() {
    $mobileButton.toggleClass('is-active');
    $menuWrap.toggleClass('is-active');
    $('body').toggleClass('scroll-lock');
  }

  function stopSubMenuPropagation(e) {
    e.stopPropagation();
  }

  // First Tier link functionality - toggles active class and applies hidden class when needed
  function firstTierMenuLinks() {
    if ($(this).hasClass('is-active')) {
      // user clicked active link lets remove active and hidden classes
      $(this).removeClass('is-active');
      $topLevelLinks.removeClass('hidden');
      $mobileSubMenus.removeClass('is-active');
      closeAllDropdownMenus();
    } else if ($(this).hasClass('has-sub')) {
      // user clicked non active link lets add appropriate classes and activate sub menu if link contains sub menu
      $(this).addClass('is-active');
      $(this > $mobileSubMenus).addClass('is-active');

      // add active class to sub menu within active tier 1 link
      $topLevelLinks.each(function (index, elm) {
        if ($(this).hasClass('is-active')) {
          $(this).find('> ul').addClass('is-active');
        } else {
          $(this).addClass('hidden');
        }
      });
    }
  }

  /**
   * Toggle dropdown for a tier 2 menu item.
   */
  function setupDropdownMenus() {
    $dropdownMenus = $('.mobile-navigation .menu-level-1 .menu-item--expanded');
    $dropdownLinks = $dropdownMenus.find('> a');

    // Stop if there are no dropdown menu items.
    if (!$dropdownMenus) return false;

    $dropdownLinks.on('click', handleDropdownToggle);
  }

  /**
   * User clicks a link with a menu below it.
   */
  function handleDropdownToggle(e) {
    e.preventDefault();

    const $el = $(e.currentTarget);

    let $thisMenu = $el.siblings('.menu-dropdown');

    if ($thisMenu.hasClass('is-open')) {
      $thisMenu.slideUp($menuSpeed);
    } else {
      $thisMenu.slideDown($menuSpeed);
      // Close open sibling menus.
      let $openSiblings = $thisMenu
        .parent()
        .siblings('.menu-item--expanded')
        .find('.menu-dropdown.is-open');
      $openSiblings.slideToggle($menuSpeed);
      $openSiblings.removeClass('is-open');
    }

    $thisMenu.toggleClass('is-open');
  }

  /**
   * Close all open menus.
   */
  function closeAllDropdownMenus() {
    let $openMenus = $dropdownMenus.find('.menu-dropdown.is-open');
    $openMenus.removeClass('is-open');
    // Delay closing so the main menu closes with dropdowns in the same position
    $openMenus.delay($menuSpeed).slideToggle(0);
  }

  // Init function
  function initialize() {
    $mobileButton = $('.mobile-menu-toggle ');
    // no mobile button lets beat it
    if (!$mobileButton.length) return false;

    $menuWrap = $('.mobile-navigation > ul');
    $topLevelLinks = $('.mobile-navigation > ul > li');
    $mobileSubMenus = $('.mobile-navigation .menu-level-1');
    $mobileSubMenuLinks = $('.mobile-navigation .menu-level-1 a');

    setClasses();

    $mobileSubMenuLinks.on('click', stopSubMenuPropagation);
    $mobileButton.on('click', mobileToggleButton);
    $topLevelLinks.on('click', firstTierMenuLinks);

    setupDropdownMenus();
  }
})(jQuery, once);
